/* =========================================
   THE KING OF DEALS - SAVED DEALS
   ========================================= */

(() => {
  const STORAGE_KEY = 'kingSavedDeals';

  function getSavedDeals() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveDeals(deals) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(deals));
  }

  function isSaved(productId) {
    return getSavedDeals().some(
      deal => String(deal.id) === String(productId)
    );
  }

  function updateHeaderCount() {
    const count = getSavedDeals().length;

    document
      .querySelectorAll('.king-saved-deals-header__count')
      .forEach(element => {
        element.textContent = count;
      });
  }

  function updateHeart(button, saved) {
    button.classList.toggle('is-saved', saved);

    const isFrench =
      document.documentElement.lang &&
      document.documentElement.lang.toLowerCase().startsWith('fr');

    button.setAttribute(
      'aria-label',
      saved
        ? (isFrench
            ? 'Retirer des deals sauvegardés'
            : 'Remove from saved deals')
        : (isFrench
            ? 'Sauvegarder ce deal'
            : 'Save this deal')
    );
  }

  function updateAllHeartsForProduct(productId, saved) {
    document
      .querySelectorAll(
        `.king-save-deal[data-product-id="${productId}"]`
      )
      .forEach(button => {
        updateHeart(button, saved);
      });
  }

  function initializeHearts() {
    document.querySelectorAll('.king-save-deal').forEach(button => {
      updateHeart(
        button,
        isSaved(button.dataset.productId)
      );
    });

    updateHeaderCount();
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('.king-save-deal');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const product = {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl
    };

    let deals = getSavedDeals();

    const existingIndex = deals.findIndex(
      deal => String(deal.id) === String(product.id)
    );

    let saved;

    if (existingIndex >= 0) {
      deals.splice(existingIndex, 1);
      saved = false;
    } else {
      deals.push(product);
      saved = true;
    }

    saveDeals(deals);

    updateAllHeartsForProduct(product.id, saved);
    updateHeaderCount();

    document.dispatchEvent(
      new CustomEvent('king:saved-deals-changed', {
        detail: {
          count: deals.length
        }
      })
    );
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeHearts
    );
  } else {
    initializeHearts();
  }
  /* =========================================
   KING OF DEALS - POSITION CARD HEART
   Bottom-right corner of product image
   ========================================= */

function positionCardSaveHearts() {
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const gap = isMobile ? 8 : 10;

  document.querySelectorAll('.product-card-wrapper').forEach((wrapper) => {
    const heart = wrapper.querySelector(':scope > .king-save-deal');
    const media = wrapper.querySelector('.card__media');

    if (!heart || !media) return;

    const wrapperRect = wrapper.getBoundingClientRect();
    const mediaRect = media.getBoundingClientRect();

    const heartHeight =
      heart.getBoundingClientRect().height || (isMobile ? 36 : 40);

    const heartTop =
      mediaRect.bottom -
      wrapperRect.top -
      heartHeight -
      gap;

    heart.style.setProperty(
      '--king-heart-top',
      `${Math.max(gap, heartTop)}px`
    );
  });
}

function refreshCardHeartPositions() {
  requestAnimationFrame(() => {
    positionCardSaveHearts();

    requestAnimationFrame(() => {
      positionCardSaveHearts();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    refreshCardHeartPositions
  );
} else {
  refreshCardHeartPositions();
}

window.addEventListener('load', refreshCardHeartPositions);
window.addEventListener('resize', refreshCardHeartPositions);

document.addEventListener(
  'shopify:section:load',
  refreshCardHeartPositions
);

document.querySelectorAll('.product-card-wrapper img').forEach((img) => {
  if (!img.complete) {
    img.addEventListener(
      'load',
      refreshCardHeartPositions,
      { once: true }
    );
  }
});
})();